import React, { useState, useEffect, useCallback } from "react";
import Back from "assets/images/svg/back_blue.svg";
import { Link, useNavigate } from "react-router-dom";
import PricingCard from "./component/pricingCard";
import Minus from "assets/images/svg/minus_gray.svg";
import Right from "assets/images/svg/right_green.svg";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { AppDetailService } from "pages/details/app-detail.service";
import { useTranslation } from "react-i18next";
import ErrorMessage from "components/error/error";
import { Spinner } from "react-bootstrap";
import PricingForm from "./component/pricingForm";
import { json } from "helpers/data";
import _ from "lodash";

const PricingPlans = () => {
	const { t } = useTranslation("browse-apps");
	const [priceLevelId, setPriceLevelId] = React.useState('');
	const [versionReleaseId, setVersionReleaseId] = React.useState('');
	const [versionId, setVersionId] = React.useState('');
	const [countryPayId, setCountryPayId] = React.useState('');


	const [subscriptionType, setSubscriptionType] = React.useState('Monthly');
	const params = useParams();
	const navigate = useNavigate()
	const appId = params.id;
	const [scrolling, setScrolling] = useState(false);
	const [displayBtn, setDisplayBtn] = useState(false);
	const [scrollTop, setScrollTop] = useState(0);

	const onScroll =useCallback ((e) => {
		setScrollTop(e.target.documentElement.scrollTop);
		setScrolling(e.target.documentElement.scrollTop > scrollTop);
	},[scrollTop]);

	useEffect(() => {
		window.addEventListener("scroll", onScroll);
	}, [onScroll]);

	
	useEffect(() => {
		checkBuyBtnDisplay(scrollTop);
	}, [scrollTop]);

	const checkBuyBtnDisplay = (height) => {
		if (height > 450) {
			setDisplayBtn(true);
		} else {
			setDisplayBtn(false);
		}
	};

	const {
		data: appVersions,
		isLoading,
		isFetching,
		isSuccess,
		isError,
	} = useQuery(["app-pricing", appId], () =>
		AppDetailService.getPricingAndPlans(appId).then((r) => r.response),
		{onSuccess:()=> checkSubscription(),cacheTime: 0}
	);

	const { data: availableVersion } = useQuery(
		["app-available-version", appId, priceLevelId],
		() =>
			AppDetailService.getAvailableVersionsByApp(appId, priceLevelId).then(
				(r) => r.response
			),
		{ onSuccess: () => checkSubscription() ,cacheTime: 0}
	);

	const checkSubscription = ()=>{
		if(appVersions?.application?.subscriptionType?.id === 1){
			setSubscriptionType("Forever")
		}
		
	}
	
	const getAvailableVersionRows = (id) => {
		return (
			isSuccess &&
			availableVersion?.map((item) => {
				return (
					<td key={item.id}>
						{item?.availabeFeatures?.length > 0 ? (
							getFeaturesByVersion(item?.availabeFeatures, id)
						) : (
							<img src={Minus} alt="" />
						)}{" "}
					</td>
				);
			})
		);
	};

	const getFeaturesByVersion = (features, id) => {
		const featureArr = _.filter(features, function (o) {
			return o.featureId === id;
		});
		if (featureArr.length > 0) {
			return featureArr.map((feature) => {
				const result = _.isEmpty(feature.moreDetail) ? (
					<img src={Right} alt=""  key={feature.id}/>
				) : (
					feature.moreDetail
				);
				return result;
			});
		} else {
			return <img src={Minus} alt="" />;
		}
	};

	const handleSubmit=(data)=>{
	navigate(`../payment-details/?VersionId=${versionId}&PriceLevelId=${data.packages}&Discriminate=${data.billing}&versionReleaseId=${versionReleaseId}&paymentCountryId=${countryPayId}`)
	}

	return (
		<div className="pricing">
			<div className="header">
				<Link to={`/app/${appId}`}>
					<img className="back" src={Back} alt="back" />
				</Link>
				<h1 className="title">
					{json(appVersions?.application?.name)}{" "}
				</h1>
			</div>
			<hr className="hr" />
			<div className="row">
				<div className="col-xl-3  col-md-12">
					<div className="packages">
						<PricingForm
							packages={isSuccess ? appVersions?.packages : []}
							onPriceLevelChange={setPriceLevelId}
							onSubsriptionType = {setSubscriptionType}
							handleSubmit={handleSubmit}
						/>
					</div>
				</div>
				{isError && <ErrorMessage />}
				{(isLoading || isFetching) && (
					<div className="my-center">
						<Spinner animation="grow" variant="primary" />
					</div>
				)}
				{isSuccess &&
					availableVersion?.map((item) => {
						return (
							<div
								className="col-xl-3 col-lg-4 col-md-4 mx-auto"
								key={item.id}
							>
								<PricingCard version={item} subscriptionType={subscriptionType} onChangeVersion={setVersionId} onChangeRelease={setVersionReleaseId} onChangeCountryPay={setCountryPayId} />
							</div>
						);
					})}
				<div className="col-12 scrollX">
					<table className="table">
						<thead>
							<tr>
								<th>
									<span>{t("pricingPlan.features")}</span>
								</th>
								{isSuccess &&
									availableVersion?.map((v) => {
										return (
											<th key={v.id}>
												<p className="table-title">{json(v.name)}</p>
												<button
													className="btn-White"
													type="submit" 
													form="hook-form"
													style={{
														visibility: displayBtn
															? "visible"
															: "hidden",
													}}
													onClick={()=> navigate('../../payment-details')}

												>
													{t('details:addonDetails.buyNow')}
												</button>
											</th>
										);
									})}
							</tr>
						</thead>
						<tbody>
							{isSuccess &&
								appVersions?.features?.map((feature) => {
									return (
										<tr key={feature.id}>
											<td>{json(feature.name)}</td>
											{getAvailableVersionRows(
												feature?.id
											)}
										</tr>
									);
								})}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default PricingPlans;
